'use client'
import { useTranslations } from 'next-intl'
import React from 'react'
import styles from './styles.module.scss'

interface ButtonProps {
  size?: 'small' | 'normal'
  typeButton: 'desktop' | 'mobile'
  className?: string
  hasIcon?: boolean
  onClick?: () => void
}

const PlayNowBtn = ({
  typeButton,
  hasIcon = true,
  className = '',
  ...props
}: ButtonProps) => {
  const t = useTranslations('translation')

  return (
    <button
      className={`${styles.button} ${
        props.size === 'small' ? styles.small : ''
      } ${className}`}
      style={{ width: typeButton === 'mobile' ? '100%' : 'initial' }}
      {...props}
    >
      {/*eslint-disable-next-line*/}
      {hasIcon && <img src="/img/play-icon.svg" alt="play" />}
      {hasIcon && (
        <img
          className={styles.withActive}
          src="/img/play-icon-active.svg"
          alt="play"
        />
      )}
      <span>{t('playNow')}</span>
    </button>
  )
}
export default PlayNowBtn
